import { useMutation, useQuery } from '@tanstack/react-query';
import {
  commonAxiosError,
  commonAxiosSuccess,
  queryClient,
} from '../../../Utils/TanstackQuery/queryClient';
import { httpService } from '../../../Helpers/Fetcher/axios';
import { pubAndSerApi } from './constantPubAndSer';
import {
  ICreateLeadVisitorOnly,
  TPublicProductAndServiceList,
} from './pubAndSerTypes';

export const useAddPubAndServiceWhishList = () => {
  return useMutation({
    mutationFn: ({ product_id }: { product_id: number }) =>
      httpService.post({
        url: `${pubAndSerApi.ADD_WHIST_LIST}`,
        data: { product_id: product_id },
      }),
    onSuccess: (res) => {
      commonAxiosSuccess(`Successfully ${res?.message}`);
      queryClient.invalidateQueries({
        queryKey: [pubAndSerApi.GET_PUBLIC_PRODUCT_AND_SERVICE],
      });
    },
  });
};

export const useAddLeadNonRegisterVisitorInfo = () => {
  return useMutation({
    mutationFn: (data: ICreateLeadVisitorOnly) =>
      httpService.post({
        url: `${pubAndSerApi.ADD_NON_VISITOR_INFORMATION}`,
        data,
      }),
    onSuccess: (res) => {
      commonAxiosSuccess(`Successfully ${res?.message}`);
      // queryClient.invalidateQueries({
      //   queryKey: [pubAndSerApi.GET_PUBLIC_PRODUCT_AND_SERVICE],
      // });
    },

    onError: commonAxiosError(),
  });
};
export const useAddLogInVisitorComments = (id: number) => {
  return useMutation({
    mutationFn: (data: { comment: string }) =>
      httpService.post({
        url: `${pubAndSerApi.LOGIN_VISITOR_COMMENTS}/${id}`,
        data,
      }),
    onSuccess: (res) => {
      commonAxiosSuccess(`Successfully ${res?.message}`);
      // queryClient.invalidateQueries({
      //   queryKey: [pubAndSerApi.GET_PUBLIC_PRODUCT_AND_SERVICE],
      // });
    },

    onError: commonAxiosError(),
  });
};

export const useGetPublicProductAndService = (filter: {
  productName: string;
  exhibitor: string | number;
  category_id: string;
}) => {
  return useQuery({
    queryKey: [pubAndSerApi.GET_PUBLIC_PRODUCT_AND_SERVICE, filter],
    queryFn: () =>
      httpService.get<TPublicProductAndServiceList[]>({
        url: pubAndSerApi.GET_PUBLIC_PRODUCT_AND_SERVICE,
        params: filter,
      }),
  });
};
